export default{
    setNegocios(state,negocios){
        state.negociosArray = negocios;
    },
    setImpresoras(state,imp){
        state.impresorasNegocio = imp;
    },
    setComputers(state,pcs){
        state.ordenadoresNegocio = pcs;
    },
    setClientesNegocio(state,neg){
        state.clientesNegocio = neg;
    },
    setPedidosArray(state,ped){
        state.pedidosArray = ped;
    }
}